import * as _4 from 'lodash4';
interface IResourceResponse {
  resource: any;
  location: any;
  item: Record<string, { resources: Record<string, any> }>;
}
angular.module('data-ng-todos').config(($provide: any) => {
  $provide.decorator('pathItemContractModifierDecorator', ($delegate: any, resourceModel: any) => {
    $delegate.addExtension('topic', (data: any) => {
      if (_4.isUndefined(data.topic) || _4.isEmpty(data.topic)) {
        return {};
      }
      return _4.first(_4.valuesIn(data.topic));
    });

    $delegate.addExtension('resource', (data: IResourceResponse) => {
      if (_4.isUndefined(data.resource) || _4.isEmpty(data.resource)) {
        return {};
      }

      resourceModel.update({
        resource: data.resource,
        location: data.location
      });
      const resourcesData = _4.first(_4.values<IResourceResponse['item']>(data.item)).resources;
      return resourceModel.getResourcesByListOfIds(resourcesData);
    });

    return $delegate;
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/decorators/path_item_decorator.ts